import { render } from "./HsTabs.vue?vue&type=template&id=2fd73b4a&scoped=true"
import script from "./HsTabs.vue?vue&type=script&lang=js"
export * from "./HsTabs.vue?vue&type=script&lang=js"

import "./HsTabs.vue?vue&type=style&index=0&id=2fd73b4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fd73b4a"]])

export default __exports__